import { ZyDEIcon } from '@/components/tiptap-editor/tiptap-icons/zyde-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyDEButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyDE"
        extensionType="node"
        icon={ZyDEIcon}
        label="Insert zyDE"
        isDisabled={editor => !isSelectionTopNode(editor)}
        command={editor => editor.commands.insertZyDE()}
        ref={ref}
        {...props}
    />
));

ZyDEButton.displayName = 'ZyDEButton';

export default ZyDEButton;
